module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMxJREFUeNpiYEAHUZ+uOoBoJiDjP0wQIIAwlcClAQIIK2CEKgOpcASxl/FpHwAIIAaiAFBXGgsSB2ZJOhOaAANOVwIEENH2MOGRdEA2mQU9dKBgP8x/cIVY3OPIQAkACCCiASMxPgaHGbEmsuAxCR4tWBUiRz1WE6HheAGXDUxogWyAUyGxCYCJ6gEOEGD0j0Fi0zXBCMSX7qEhzgDNtoxEpQgkAwSQousC2UkMCRgguciRZAPR0gfJmRGUo5HDg+LcDHKhAzWTzeBP2QClH06an7txZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/alarmList/list_icon_signal_4.png
// module id = 6s5Z
// module chunks = 1